import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css'; 
// import bg1 from '../../assets/mainbg.jpg'; 
// import bg from '../../assets/bg.jpg'
import bg2 from '../../assets/bg1.jpeg'
import amazon from  '../../assets/amazon.png'
import flipkart from '../../assets/flipkart.png'
import meesho from '../../assets/meesho.jpg'
import big from '../../assets/bigbasket.png'
import express from '../../assets/express.png'
import shree from '../../assets/shree maruti.jpg'
import logo from '../../assets/logo2.jpg'
import irctc from '../../assets/logo.png'
import swiggy from '../../assets/swiggy.png'
import zomato from '../../assets/zomato.jpg'
import './About.css'

AOS.init(); 

const About = () => {
  return (
    <div>
      <section
        className="hero-section"
        style={{
          position: 'relative',
          backgroundImage: `url(${bg2})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '400px',
          color: 'white',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)', 
            zIndex: 1,
          }}
        ></div>

        <h1
          data-aos="fade-in"
          className="display-4"
          style={{ position: 'relative', zIndex: 2 }} 
        >
          Shivek Group : Where Every Solution Begins.
        </h1>
        {/* <p
          data-aos="fade-in"
          className="lead"
          style={{ position: 'relative', zIndex: 2 }} 
        >
          Where Every Solution Begins.
        </p> */}
      </section>

      <Container className="py-5">
        <Row>
          <Col md={6} data-aos="fade-up">
            <h2>Company Overview</h2>
            <p style={{textAlign:'justify'}}>
            Shivek Group is a leading provider of diverse services across logistics, food, e-
commerce, travel, real estate, and business solutions. With a strong presence in
India, we specialize in delivering tailored, high-quality solutions that ensure customer
satisfaction and business growth. Our expertise and commitment to excellence make
us a trusted partner across various industries, helping clients achieve success with
efficiency and reliability.
            </p>
          </Col>
          <Col md={6} data-aos="fade-up">
            <Image src={logo} alt="Company" fluid rounded />
          </Col>
        </Row>
      </Container>


       {/*  <div className="my-5">
                  <h2 className="text-center mb-4">Our Esteemed Clients</h2>
                  <Row className="text-center">
                    <Col md={1.5}>
                      <img src={amazon} alt="Amazon" className="img-fluid1" />
                    </Col>
                    <Col md={1.5}>
                      <img src={flipkart} alt="Flipkart" className="img-fluid1" />
                    </Col>
                    <Col md={1.5}>
                      <img src={meesho}  alt="Meesho" className="img-fluid1" />
                    </Col>
                    <Col md={1.5}>
                      <img src={big}  alt="Big Basket" className="img-fluid1" />
                    </Col>
                    <Col md={1.5}>
                      <img src={express}  alt="Xpress Bees" className="img-fluid1" />
                    </Col>
                    <Col md={1.5}>
                      <img src={shree}  alt="Shree Maruti" className="img-fluid1" />
                    </Col>
                    <Col md={1.5}>
                      <img src={zomato}  alt="Zomato" className="img-fluid1" />
                    </Col>
                    <Col md={1.5}>
                      <img src={swiggy}  alt="Swiggy" className="img-fluid1" />
                    </Col>
                    <Col md={1.5}>
                      <img src={irctc}  alt="IRCTC" className="img-fluid1" />
                    </Col>
                  </Row>
                </div>*/}


<div className="my-5">
  <h2 className="text-center mb-4">Our Esteemed Clients</h2>
  <Row className="text-center d-flex justify-content-center flex-nowrap">
    <Col md={1} className="d-flex justify-content-center">
      <img src={amazon} alt="Amazon" className="img-fluid1" />
    </Col>
    <Col md={1} className="d-flex justify-content-center">
      <img src={flipkart} alt="Flipkart" className="img-fluid1" />
    </Col>
    <Col md={1} className="d-flex justify-content-center">
      <img src={meesho} alt="Meesho" className="img-fluid1" />
    </Col>
    <Col md={1} className="d-flex justify-content-center">
      <img src={big} alt="Big Basket" className="img-fluid1" />
    </Col>
    <Col md={1} className="d-flex justify-content-center">
      <img src={express} alt="Xpress Bees" className="img-fluid1" />
    </Col>
    <Col md={1} className="d-flex justify-content-center">
      <img src={shree} alt="Shree Maruti" className="img-fluid1" />
    </Col>
    <Col md={1} className="d-flex justify-content-center">
      <img src={zomato} alt="Zomato" className="img-fluid1" />
    </Col>
    <Col md={1} className="d-flex justify-content-center">
      <img src={swiggy} alt="Swiggy" className="img-fluid1" />
    </Col>
    <Col md={1} className="d-flex justify-content-center">
      <img src={irctc} alt="IRCTC" className="img-fluid1" />
    </Col>
  </Row>
</div>


    </div>
  );
};

export default About;
